import { TbHelpCircleFilled } from "react-icons/tb"
import { Popover, PopoverContent, PopoverTrigger } from "../Popover"
import { cn } from "../../lib/utils";
import { cva } from "class-variance-authority"

const helpPopoverClass = cva("font-medium items-center flex space-x-2")

const HelpPopover = ({title, helpText, align, className}:{title: string, helpText?: string, align?: "center" | "start" | "end", className?: string}) => {
    return (
        <div className={cn(helpPopoverClass(), className)}>
            <span>{title}</span>
            {helpText && <Popover>
                <PopoverTrigger><TbHelpCircleFilled size={14} className="text-border"/></PopoverTrigger>
                <PopoverContent className="p-3 text-sm" align={align ? align : "start"}>{helpText}</PopoverContent>
            </Popover>}
        </div>
    )
}

export default HelpPopover;